export default "__VITE_ASSET__dfnStG9g__ 500w";